import ReactPlayer from 'react-player';

import adsPolish from '../files/lectorFiles/ads polish.mp3'
import interviewCorect from '../files/lectorFiles/Interview corect.mp3'
import michalNiemiec from '../files/lectorFiles/michal niemiec.mp3'

import './styles/lectorPage.scss'

function LectorPage() {
    return (
        <div className="main-page">
            <div className='title-with-description'>
                <div className='title'>
                    <h1>Lektor</h1>
                </div>
                <div className='description'>
                    <span>Oprócz tworzenia filmów zajmuję się użyczaniem głosu jako lektor i realizacją nagrań dźwiękowych w różnych warunkach.  </span>
                </div>
            </div>
            <hr></hr>
            <div className='lector-container'>
                <div className='audio-files'>
                    <div className="first-row">
                        <div className='audio' data-aos="fade-right">
                            <audio controls>
                                <source src={adsPolish} type="audio/mpeg" />
                                Twoja przeglądarka nie obsługuje elementu audio.
                            </audio>
                        </div>
                        <div className='audio' data-aos="fade-left">
                            <audio controls>
                                <source src={interviewCorect} type="audio/mpeg" />
                                Twoja przeglądarka nie obsługuje elementu audio.
                            </audio>
                        </div>
                    </div>
                    <div className="second-row">
                        <div className='audio' data-aos="fade-up">
                            <audio controls>
                                <source src={michalNiemiec} type="audio/mpeg" />
                                Twoja przeglądarka nie obsługuje elementu audio.
                            </audio>
                        </div>
                    </div>
                </div>
                <div className='videos'>
                    <div className="first-row">
                        <div className='video-player' data-aos="flip-left" data-aos-delay="200">
                            <ReactPlayer
                                className='react-player'
                                url="https://www.youtube.com/watch?v=PgveCWQ9NcI"
                                controls={true}
                                width='100%'
                                height='100%'

                                fallback={<div>Ładowanie</div>}
                            />
                        </div>
                        <div className='video-player' data-aos="flip-left" data-aos-delay="500">
                            <ReactPlayer
                                className='react-player'
                                url="https://www.youtube.com/watch?v=yOV6SDDUJOA"
                                controls={true}
                                width='100%'
                                height='100%'
                                fallback={<div>Ładowanie</div>}
                            />
                        </div>
                    </div>
                    <div className="second-row">
                        <div className='video-player' data-aos="flip-left" data-aos-delay="100">
                            <ReactPlayer
                                className='react-player'
                                url="https://www.youtube.com/watch?v=KZ7bG8vXQZY"
                                controls={true}
                                width='100%'
                                height='100%'
                                fallback={<div>Ładowanie</div>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LectorPage;